// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/smile02.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/smile01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"%23ffffff\"><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230c63e4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "SF Pro Display", sans-serif;
}

.bgblack {
  background-color: black;
}
.textgrey {
  /* color: #616161; */
  color: #b5b5b5;
}
.bg3 {
  background-color: #101010;
}
.bg4 {
  background-color: #1f1d1b;
}
.text_purple {
  color: #9607b1;
}
.text_blue {
  color: #2d62ed;
}
.fontsize13 {
  font-size: 13px;
}
.fontsize14 {
  font-size: 14px;
}
.fontsize12 {
  font-size: 12px;
}
.textgrey2 {
  color: #8d8b8b;
}
.textgrey3 {
  color: #616161;
}
.textgrey4 {
  color: #b7b7b7;
}
.textblack{
  color: black;
}

.tech-p {
  font-size: 24px;
}
.fontsize18{
  font-size: 18px;
}
.bg_green {
  background-color: #6adc26;
}
.text_green {
  color: #6adc26;
}
.bglightgrey {
  background-color: #f2f3f6;
}
.bglightgrey {
  background-color: #f2f3f6;
}

.cursor {
  cursor: pointer;
}
.textgreen {
  color: #6adc26;
}
.fontsize13 {
  font-size: 13px;
}

.bglightblack{
  background-color: #1F1D1B;
}

.navbar_list li a {
  color: #c6c3c3;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  padding: 10px 15px;
  position: relative;
  font-size: 14px;
}

.navbar-nav a:hover {
  color: #6adc26;
}

.navbar_list li a:after {
  background: none repeat scroll 0 0 transparent;
  bottom: 3px;
  content: "";
  display: block;
  height: 1px;
  left: 50%;
  position: absolute;
  background: #6adc26;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
}

.navbar_list li a:hover:after {
  width: 100%;
  left: 0;
}
.textwhite_light{
  color: #c6c3c3;
}

.hovermenu_list a {
  text-transform: capitalize;
  text-decoration: none;
  color: #929292;
  font-size: 21px;
  line-height: 38px;
}
.hover_desc h1 {
  font-size: 60px;
}
.hovermenu_list a:hover {
  color: #6adc26;
}
.hovermenu_list2 a {
  text-transform: capitalize;
  text-decoration: none;
  color: #6adc26;
  font-size: 21px;
  line-height: 38px;
}
.hovermenu_list2 a:hover {
  color: #929292;
}
.container > div .bg-video {
  width: 100%;
  height: 90vh;
  object-fit: cover;
 
}
.Revolutionary_text {
  margin-top: -5%;
}
.eye-girl-text {
  background-color: #cdbfbc;
}
.container >div  .video_text {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  background-color: black;
  color: #fff;
  font-size: 23vw; /* Use vw (viewport width) for responsive font size */
  mix-blend-mode: multiply;
  z-index: 0;
}
.meet_text {
  position: absolute;
  font-size: 1.7vw;
  margin-left: 62%;
  bottom: 18%;
  /* background-color: #6adc26; */
}

.welcome_text h1 {
  font-size: 4.3vw;
}
.experience_text h1 {
  font-size: 6.3vw;
}
.experience_desc {
  font-size: 1.3vw;
}
.body_mind_text{
  margin-top: -1%;
}
.welcome_div h4{
  font-size: 1.6vw;
}
.welcome_div p{
  font-size: 1.1vw;
}

.card_img {
  position: absolute;
  top: 0;
  /* height: 550px; */
  left: -50%;
  z-index:0;
  transition: transform 0.3s ease-in-out;
  /* transform: rotateY(0deg); */
  /* transform: skewX(-10deg) skewY(-15deg) rotateY(55deg); */

}


.card_img2 {
  z-index: 0;
  height: 550px;
  transition: transform 0.3s ease-in-out;
  /* transform: skewX(-10deg) skewY(-25deg) rotateY(55deg); */
 
}

.card_animation:hover{
  animation: down 5s linear infinite;
  /* z-index: 1000 !important; */
}
@keyframes down {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(30deg);
  }
  
  100% {
    transform: rotateY(0deg);
  }
}

 .card_img:hover {

  transform: skewX(0deg) skewY(deg)
} 
.card_img2:hover {
  transform: translateX(50%);
  z-index: 1000 !important;
  transition: transform 0.3s ease-in-out;
} 


/* .card_1:hover .card_img2 {
  transform: translateX(10%);
  transform: rotateY(30deg);
  z-index: 0;

} */

.form__group {
  position: relative;
  padding: 20px 0 0;
  margin-top: 10px;
  width: 85%;
}

.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid #ccc;
  outline: 0;
  color: black;
  padding: 11px 0px;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  /* font-size: 1.3rem; */
  cursor: text;
  top: 30px;
}

.form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 1rem;
  color: #ccc; /* Replace \$gray with the desired color value */
}

.form__field:focus {
  padding-bottom: 10px;
  font-weight: 100;
  border-width: 3px;
  border-image: linear-gradient(to right, #6adc26, #6adc26);
  border-image-slice: 1;
}

/* Reset input */
.form__field:required,
.form__field:invalid {
  box-shadow: none;
}

.submit_btn {
  width: 220px;
  padding: 7px;
}
.order_div p {
  margin: 0;
}

.comp_main {
  color: #8d8b8b;
  background-color: #101010;
}

.comp_benefits {
  font-size: 1.3vw;
  position: absolute;
  bottom: 47%;
  left: 41%;
  z-index: 1;
  color: #b9abb1;
}

.comp_benefits h2 {
  font-size: 2vw;
}

.compmobbene {
  bottom: 45%;
  left: 36%;
  position: absolute;
  font-size: 3vw;
  z-index: 1;
  color: #b9abb1;
}

.compmobbene h2 {
  font-size: 4vw;
}

.compcontent {
  max-width: 60%;
}

.compcontent p {
  font-size: 22px;
}

.mobbenif {
  overflow: hidden !important;
  position: relative;
  /* max-width: 100%;
  max-height: 100%; */
}

.benefitmobimg {
  /* transition: transform 0.7s ease-in-out; */
  animation: rotate 100s linear infinite;
  /* max-width: 1100px; */
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
/* .benefitmobimg:hover {
  transform: rotate(60deg);
} */

.benefitsimg {
  /* transition: transform 0.7s ease-in-out; */
  animation: rotate 100s linear infinite;
}

/* .benefitsimg:hover {
  transform: rotate(60deg);
} */


.greycircle {
  position: absolute;
  bottom: 27%;
  left: 31%;
  opacity: 1;
  width: 38%;
}

.greycircle1 {
  position: absolute;
  bottom: 23%;
  left: 23%;
  opacity: 1;
  width: 53%;
}

.mobsmiley {
  width: 60px;
  height: 60px;
}

.mobsmiley1 {
  z-index: 1;
  width: 65px;
  height: 63px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}

.benitem:hover > .mobsmiley1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.benitem:hover > p {
  background-color: #6adc26;
  color: black;
  border-radius: 15px;
}

.benmobbtn1 {
  background-color: #1f1d1b;
  color: white;
  border-radius: 10px;
  border: 100px;
  font-size: 24px;
  width: 250px;
}

.benmobbtn2 {
  background-color: #2d62ed;
  color: white;
  border-radius: 10px;
  border: 100px;
  font-size: 18px;
  width: 250px;
}

.verline {
  height: 40px;
  width: 2px;
  background-color: #2d62ed;
}
.smiley1img {
  z-index: 1;
  width: 25%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}

/* .smiley1img:hover {
  background-image: url("../../public/images/smile01.png");
} */

/* .smiley1 > .smiley1img {
  background-image: url("../../public/images/smile01.png");
}
.smiley1 > p {
  background-color: #6adc26;
  color: black;
  border-radius: 30px;
} */

.smiley1 {
  position: absolute;
  bottom: 70%;
  right: 72%;
}

.smiley1 p {
  font-size: 1vw;
  border: 5px;
  border-radius: 30px;
  line-height: 19px;
}


.smiley2img {
  width: 37%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}

.smiley2:hover > .smiley2img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.smiley2:hover > p {
  background-color: #6adc26;
  color: black;
  border-radius: 30px;
}

.smiley-hover-effect > div {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});

}
.smiley-hover-effect > p {
  background-color: #6adc26;
  color: black;
  border-radius: 30px;

}

.smiley2 {
  position: absolute;
  bottom: 53%;
  right: 79%;
  z-index: 1;
}

.smiley2 p {
  font-size: 1vw;
  border: 5px;
  border-radius: 30px;
  line-height: 19px;
}

.smiley3img {
  z-index: 1;
  width: 30%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}

.smiley3 {
  position: absolute;
  bottom: 34%;
  right: 78%;
  z-index: 1;
}

.smiley3 p {
  font-size: 1vw;
  border: 5px;
  border-radius: 30px;
  line-height: 19px;
}

.smiley3:hover > .smiley3img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.smiley3:hover > p {
  background-color: #6adc26;
  color: black;
  border-radius: 30px;
}

.smiley4img {
  z-index: 1;
  width: 22%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}

.smiley4 {
  position: absolute;
  bottom: 18%;
  right: 68%;
}

.smiley4 p {
  font-size: 1vw;
  border: 5px;
  border-radius: 30px;
  line-height: 19px;
}

.smiley4:hover > .smiley4img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.smiley4:hover > p {
  background-color: #6adc26;
  color: black;
  border-radius: 30px;
}

.visitus {
  font-size: 12px;
}

.eclipse {
  position: absolute;
  bottom: 18%;
  left: 18%;
  width: 20%;
}

.tech-ben-con1 {
  position: absolute;
  bottom: 35%;
  left: 78%;
  color: #8d8b8b;
  width: 300px;
}

.tech-ben-con1 h6 {
  font-size: 1.5vw;
}

.tech-ben-con1 p {
  font-size: 1vw;
  color: #7de01f;
}

.benbtn1 {
  background-color: #1f1d1b;
  width: 100%;
  color: white;
  font-size: 1vw;
  border-radius: 10px;
  border: 100px;

}

.benbtn1:hover {
  background-color:#1f1d1b; 
  /* text-decoration: underline; */
  text-underline-offset: 3px;;
  color: #6adc26;
  
}
.benbtn2 {
  background-color: #2d62ed;
  width: 123px;
  color: white;
  font-size: 0.9vw;
  border-radius: 10px;
  border: 100px;
  height: 100%;
}
.benbtn2:hover {
  background-color: #6adc26;;
  width: 123px;
  color:black;
  font-weight: 600;
  font-size: 0.9vw;
  text-underline-offset: 3px;
  border-radius: 10px;
  border: 100px;
}

/* .pendamic_font{
  font-size: 1vw !important;
} */

.tech-card {
  background-color: #1f1d1b;
  height: 500px;
  width: 543px;
  border-radius: 15px;
}
.card_design {
  background-color: #1f1d1b;
  height: 460px;
  width: 500px;
  border-radius: 15px;
}

.tech-card p {
  font-size: 18px;
}

.techimg1 {
  width: 200px;
}

.techimg2 {
  width: 300px;
}
.techimg3 {
  width: 177px;
  top: 9%;
}

.tech-uses-p {
  font-size: 16px;
  color: #b5b5b5;
}

.techimg4 {
  width: 80%;
  border-radius: 15px;
}

.benefits-card {
  background-color: #1f1d1b;
  max-height: 75%;
  width: 80%;
  border-radius: 20px;
}

.tech-card-icon {
  width: 75px;
}

.benefits-content {
  width: 25%;
}

.benefits-content p {
  font-size: 11px;
  width: 125px;
}

.tech-video-text {
  position: absolute;
  top: 10%;
  left: 0;
  height: 60%;
  width: 100%;
  display: grid;
  place-items: center;
  background-color: black;
  color: #fff;
  font-weight: 600;
  font-size: 130px;
  /* Mix Blend Mode does the all magic */
  mix-blend-mode: multiply;
}

.tech-video {
  height: 100%;
  width: 100%;
}
.checkout_btn {
  background: black;
  color: white;
  padding: 3% 39%;
  border: 0;
}
.paymethod_div {
  background-color: #fcfbda;
  border: 1px solid #e6e2be;
  border-radius: 8px;
}

.form_field_2 {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid #ccc; /* Replace \$gray with the desired color value */
  outline: 0;
  color: black; /* Replace \$white with the desired color value */
  padding: 12px 0px;
  background: transparent;
  transition: border-color 0.2s;
}
.billing_label {
  position: absolute;
  cursor: text;
  top: 32%;
  left: 7%;
}
.nav_product {
  position: absolute;
  height: 108px;
  /* height: 100%; */
  width: 65px;
  right: 0;
  top: 0;
}

.count_div {
  border-radius: 50%;
  border: 0;
  height: 13px;
  width: 13px;
  font-size: 8px;
  background-color: #1f1d1b;
  color: white;
  align-items: center;
  z-index: 999;
}
.cart_count {
  z-index: 1000;
}
.count_icon {
  position: absolute;
  bottom: 50%;
  left: 50%;
}

.bubble1 {
  position: absolute;
  bottom: 65%;
  left: 10%;
  width: 25%;
}
.bubble2 {
  position: absolute;
  bottom: 80%;
  left: 50%;
  width: 20%;
  z-index: 1000px;
}
.bubble3 {
  position: absolute;
  bottom: 85%;
  left: 75%;
  width: 14%;
}
.bubble4 {
  position: absolute;
  bottom: 65%;
  left: 65%;
  width: 14%;
}

.tech-link {
  position: absolute;
  bottom: 10%;
  left: 34%;
  transition: left 0.3s ease-out;
}

.tech-link:hover {
  left: 38%;
}
.product_link {
  color: white;
  text-decoration: none;
}
.product_link:hover {
  color: white;
}
.input-qty {
  border: none;
  background-color: white;
}

.certificate {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.overlay {
  background: blue;
  width: 100%;
  top: 0;
  position: absolute;
  bottom: 0;
  opacity: 0.5;
}
.enquiry_logo {
  top: 10%;
  left: 32%;
}
.vh100 {
  height: 100vh;
}
.checkkk {
  z-index: -1;
}
.width75 {
  width: 75%;
}

.custom-accordion .accordion-item {
  background-color: #171727;
  border-radius: 15px;
  border: none !important;
  border-bottom: none !important;
  outline: none !important;
}

.custom-accordion .accordion-button:not(.collapsed) {
  background-color: #171727 !important;
  box-shadow: none;
  color: white;
  outline: none !important;
}
.custom-accordion .accordion-button {
  background-color: #171727 !important;
  box-shadow: none;
  color: white;
  outline: none !important;
}

.custom-accordion .accordion-button:focus {
  box-shadow: none;
  outline: none;
  background-color: #171727;
  color: white;
}
.accordion-button:not(.collapsed)::after {
  content: "";
  transform: rotate(0deg);
  color: white;
}
.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}

.navbar {
  transition: opacity 0.3s ease;
  opacity: 1;
}

.navbar-hidden {
  opacity: 0;
}

.fade-in {
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-2%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.smooth {
  transition: opacity 0.3s ease;
}
body::-webkit-scrollbar {
  width: 5px;
  /* display: none;            */
}

body::-webkit-scrollbar-track {
  background: black;
}

body::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 3px solid #6adc26;
}

.accordion-button:not(.collapsed)::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  transform: rotate(0deg);
  color: #000;
}

.aboutus_div h2 {
  color: #929292;
  font-size: 27px;
  margin-top: 45px;
}

.aboutus_div p,
h4,
h5 {
  color: #929292;
}
.custom_padding {
  margin-top: 10%;
  margin-bottom: 11%;
}
.enquiry_img {
  height: 600px;
  object-fit: contain;
}
.custom_bottom {
  bottom: -8%;
}
.about_heading {
  font-size: 60px;
}
.about_desc {
  text-align: center;
}
.electron_text {
  font-size: 60px;
}

.zoom-in-zoom-out {
  transition: transform 0.3s ease-out;
}

.zoom-in-zoom-out:hover {
  transform: scale(0.9);
}

.image_effect:hover {
  transform: translateX(20px);
}
.text_hover {
  color: #c6c3c3;
}
.text_hover a {
  color: #c6c3c3;
}
.text_hover a:hover {
  color: #7de01f;
}

.certificate_heading{
  text-decoration: underline;
  text-decoration-color: #616161;
  text-underline-offset: 8px;
}
.health_font{
  font-size: 58px;
  line-height: 58px;
}
.girl_img{
  width: 150px;
}
.buy_amazon_btn:hover{
  background-color: #6adc26;
  color: white;

}
.media-img{
  height: 80px;
}
.marquee_display{
  display: block;
}
.blog_font{
  font-size: 1.3vw;
}
.blog_fon2{
  font-size: 1vw;
}

.aboutus_text h1{
  font-size: 70px;

}

.show{
  display: none;
}
.show2{
  display: block;
}
@media only screen and (max-width: 640px) {
  
  .show2{
    display: none;
  }
  .show{
    display: block;
  }
  .aboutus_text h1{
    font-size: 30px;
  
  }
  .blog_font{
    font-size: 4vw;
  }

  .blog_fon2{
    font-size: 3vw;
  }
  
  .marquee_display{
    display: none;
  }
  .girl_img{
    width:115px ;
  }
  .health_font{
    font-size: 35px;
    line-height: 40px;
  }
  .about_heading {
    font-size: 44px;
  }
  .about_desc {
    text-align: start;
  }
  .nav_product {
    position: absolute;
    height: 95px;
    /* height: 100%; */
    width: 50px;
    right: 0;
    top: 0;
  }

  .count_icon {
    position: absolute;
    bottom: 50%;
    left: 50%;
  }
  .experience_desc {
    font-size: 4.8vw;
    line-height: 26px;
  }
  
  .container >div .video_text {
    
    top: 0%;
    left: 0px;
    height: 100%;
    width: 100%;
    display: grid;
    place-items: center;
    background-color: #000;
    color: #fff;
    font-weight: 600;
    font-size: 120px;
    mix-blend-mode: multiply;
    transform: scale(1.5);
  }
  .Revolutionary_text {
    font-size: 16px;
    margin-top: -1%;
  }
  .width75 {
    width: 100%;
  }
  .container >div .bg-video {
    width: 100%;
    height: 100vh;
  }
  .tech-video-text {
    position: absolute;
    top: 10%;
    left: 0px;
    height: 22%;
    width: 100%;
    display: grid;
    place-items: center;
    background-color: #000;
    color: #fff;
    font-size: 50px;
    mix-blend-mode: multiply;
  }
  .benefits-card {
    background-color: #1f1d1b;
    max-height: 75%;
    width: 100%;
    border-radius: 20px;
  }
  .techimg4 {
    width: 100% !important;
    border-radius: 15px;
  }
  .techimg3 {
    width: 175px;
    top: 6%;
  }

  .hover_desc h1 {
    font-size: 30px;
  }
  .hovermenu_list a {
    text-transform: capitalize;
    text-decoration: none;
    color: #929292;
    font-size: 18px;
    line-height: 30px;
  }
  .hovermenu_list2 a {
    text-transform: capitalize;
    text-decoration: none;
    color: #6adc26;
    font-size: 18px;
    line-height: 30px;
  }
  .hovermenu_list2 a:hover {
    color: #929292;
  }

  .display{
    display: none;
  }

  .welcome_div h4{
    font-size: 5vw;
  }
  .welcome_div p{
    font-size: 4vw;
  }
  .tech-p {
    font-size: 20px;
  }
  .tech-card {
    height: auto;
    width: 100% !important;
  }
  .card_design {
    height: auto;
    width: 100% !important;
  }
  .benefits-content {
    width: 50%;
  }
  .check {
    margin-left: 0%;
  }

  .benbtn2 {
    background-color: #2d62ed;
    width: 50px;
    color: white;
    font-size: 0.8vw;
    border-radius: 10px;
    border: 100px;
  }

  .compcontent {
    max-width: 100%;
  }

  .card_img {
    height: 500px;
    left: -40%;
  }

  .card_img2 {
    height: 350px;
    margin-left: 20%;
  }

 
  .tech-ben-con1 h6 {
    font-size: 2vw;
  }
  .tech-ben-con1 {
    width: 80px;
    bottom: 30%;
    left: 78%;
  }
  .health_container{
    transform: rotate(-90deg);
  }  
  .meet_text {
    bottom: 36%;
    font-size: 18px;
    left: 0%;
  }
  .hover_desc h1 {
    font-size: 30px;
  }

  .welcome_text h1 {
  display: none;
  }
  .experience_text h1 {
    display: none;

  }
  .welcome_mobile_text h1{
    font-size: 10vw;
    line-height: 35px;
  }

  .body_mind_text2{
    margin-top: 0%;
    font-size: 13vw;
    line-height: 3.3rem;
  }
  .card_img {
    height: 350px;
  }
  .form__group {
    position: relative;
    padding: 20px 0 0;
    margin-top: 10px;
    width: 100%;
  }
  .vh100 {
    height: 60vh;
  }

  .enquiry_img {
    height: 550px;
    object-fit: contain;
  }
  .custom_bottom {
    bottom: -7%;
  }
  .aboutus_div h2 {
    color: #929292;
    font-size: 21px;
    margin-top: 45px;
  }
  .aboutus_div h5 {
    font-size: 16px;
  }
  .electron_text {
    font-size: 35px;
  }
  .TechHoverImg {
    
  
    margin-left: 0px !important;
  
}.bgblack {
  background-color: #101010;
}
.mobile_hover_nav{
  height: 100vh;
}
}
.input-qty {
  border: none;
  background-color: white;
}




.TechHoverImg{

    width: 100%;
    overflow: hidden;
    margin-left: 12px;
    transition: transform 0.3s ease-in-out, margin-left 0.3s ease-in-out;


}
.Tech:hover  .TechHoverImg{
  margin-left: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/style.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,WAAW;EACX,cAAc;EACd,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;;AAEnB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe,EAAE,qDAAqD;EACtE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,sCAAsC;EACtC,8BAA8B;EAC9B,2DAA2D;;AAE7D;;;AAGA;EACE,UAAU;EACV,aAAa;EACb,sCAAsC;EACtC,2DAA2D;;AAE7D;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;CAEC;;EAEC;AACF;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;AACxC;;;AAGA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB;qBACmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;;GAEG;;AAEH;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;;GAEG;;;AAGH;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;EACV,yDAAwD;EACxD,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;;;;;;GAOG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,UAAU;EACV,yDAAwD;EACxD,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yDAAwD;;AAE1D;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,yDAAwD;EACxD,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,yDAAwD;EACxD,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,cAAc;;AAEhB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,6BAA6B,EAAE,+CAA+C;EAC9E,UAAU;EACV,YAAY,EAAE,gDAAgD;EAC9D,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yDAA0R;EAC1R,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yDAAiS;EACjS,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;;AAEd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;;EAEjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,MAAM;EACR;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;;EAGA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;EACX;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;EACjB;;EAEA;EACA,aAAa;EACb;EACA;IACE,aAAa;;EAEf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,2BAA2B;;AAE/B,CAAC;EACC,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;;;;AAKA;;IAEI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oEAAoE;;;AAGxE;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["* {\n  font-family: \"SF Pro Display\", sans-serif;\n}\n\n.bgblack {\n  background-color: black;\n}\n.textgrey {\n  /* color: #616161; */\n  color: #b5b5b5;\n}\n.bg3 {\n  background-color: #101010;\n}\n.bg4 {\n  background-color: #1f1d1b;\n}\n.text_purple {\n  color: #9607b1;\n}\n.text_blue {\n  color: #2d62ed;\n}\n.fontsize13 {\n  font-size: 13px;\n}\n.fontsize14 {\n  font-size: 14px;\n}\n.fontsize12 {\n  font-size: 12px;\n}\n.textgrey2 {\n  color: #8d8b8b;\n}\n.textgrey3 {\n  color: #616161;\n}\n.textgrey4 {\n  color: #b7b7b7;\n}\n.textblack{\n  color: black;\n}\n\n.tech-p {\n  font-size: 24px;\n}\n.fontsize18{\n  font-size: 18px;\n}\n.bg_green {\n  background-color: #6adc26;\n}\n.text_green {\n  color: #6adc26;\n}\n.bglightgrey {\n  background-color: #f2f3f6;\n}\n.bglightgrey {\n  background-color: #f2f3f6;\n}\n\n.cursor {\n  cursor: pointer;\n}\n.textgreen {\n  color: #6adc26;\n}\n.fontsize13 {\n  font-size: 13px;\n}\n\n.bglightblack{\n  background-color: #1F1D1B;\n}\n\n.navbar_list li a {\n  color: #c6c3c3;\n  text-transform: uppercase;\n  text-decoration: none;\n  display: inline-block;\n  padding: 10px 15px;\n  position: relative;\n  font-size: 14px;\n}\n\n.navbar-nav a:hover {\n  color: #6adc26;\n}\n\n.navbar_list li a:after {\n  background: none repeat scroll 0 0 transparent;\n  bottom: 3px;\n  content: \"\";\n  display: block;\n  height: 1px;\n  left: 50%;\n  position: absolute;\n  background: #6adc26;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  width: 0;\n}\n\n.navbar_list li a:hover:after {\n  width: 100%;\n  left: 0;\n}\n.textwhite_light{\n  color: #c6c3c3;\n}\n\n.hovermenu_list a {\n  text-transform: capitalize;\n  text-decoration: none;\n  color: #929292;\n  font-size: 21px;\n  line-height: 38px;\n}\n.hover_desc h1 {\n  font-size: 60px;\n}\n.hovermenu_list a:hover {\n  color: #6adc26;\n}\n.hovermenu_list2 a {\n  text-transform: capitalize;\n  text-decoration: none;\n  color: #6adc26;\n  font-size: 21px;\n  line-height: 38px;\n}\n.hovermenu_list2 a:hover {\n  color: #929292;\n}\n.container > div .bg-video {\n  width: 100%;\n  height: 90vh;\n  object-fit: cover;\n \n}\n.Revolutionary_text {\n  margin-top: -5%;\n}\n.eye-girl-text {\n  background-color: #cdbfbc;\n}\n.container >div  .video_text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: grid;\n  place-items: center;\n  background-color: black;\n  color: #fff;\n  font-size: 23vw; /* Use vw (viewport width) for responsive font size */\n  mix-blend-mode: multiply;\n  z-index: 0;\n}\n.meet_text {\n  position: absolute;\n  font-size: 1.7vw;\n  margin-left: 62%;\n  bottom: 18%;\n  /* background-color: #6adc26; */\n}\n\n.welcome_text h1 {\n  font-size: 4.3vw;\n}\n.experience_text h1 {\n  font-size: 6.3vw;\n}\n.experience_desc {\n  font-size: 1.3vw;\n}\n.body_mind_text{\n  margin-top: -1%;\n}\n.welcome_div h4{\n  font-size: 1.6vw;\n}\n.welcome_div p{\n  font-size: 1.1vw;\n}\n\n.card_img {\n  position: absolute;\n  top: 0;\n  /* height: 550px; */\n  left: -50%;\n  z-index:0;\n  transition: transform 0.3s ease-in-out;\n  /* transform: rotateY(0deg); */\n  /* transform: skewX(-10deg) skewY(-15deg) rotateY(55deg); */\n\n}\n\n\n.card_img2 {\n  z-index: 0;\n  height: 550px;\n  transition: transform 0.3s ease-in-out;\n  /* transform: skewX(-10deg) skewY(-25deg) rotateY(55deg); */\n \n}\n\n.card_animation:hover{\n  animation: down 5s linear infinite;\n  /* z-index: 1000 !important; */\n}\n@keyframes down {\n  0% {\n    transform: rotateY(0deg);\n  }\n  50% {\n    transform: rotateY(30deg);\n  }\n  \n  100% {\n    transform: rotateY(0deg);\n  }\n}\n\n .card_img:hover {\n\n  transform: skewX(0deg) skewY(deg)\n} \n.card_img2:hover {\n  transform: translateX(50%);\n  z-index: 1000 !important;\n  transition: transform 0.3s ease-in-out;\n} \n\n\n/* .card_1:hover .card_img2 {\n  transform: translateX(10%);\n  transform: rotateY(30deg);\n  z-index: 0;\n\n} */\n\n.form__group {\n  position: relative;\n  padding: 20px 0 0;\n  margin-top: 10px;\n  width: 85%;\n}\n\n.form__field {\n  font-family: inherit;\n  width: 100%;\n  border: 0;\n  border-bottom: 2px solid #ccc;\n  outline: 0;\n  color: black;\n  padding: 11px 0px;\n  background: transparent;\n  transition: border-color 0.2s;\n}\n\n.form__field::placeholder {\n  color: transparent;\n}\n\n.form__field:placeholder-shown ~ .form__label {\n  /* font-size: 1.3rem; */\n  cursor: text;\n  top: 30px;\n}\n\n.form__label {\n  position: absolute;\n  top: 0;\n  display: block;\n  transition: 0.2s;\n  font-size: 1rem;\n  color: #ccc; /* Replace $gray with the desired color value */\n}\n\n.form__field:focus {\n  padding-bottom: 10px;\n  font-weight: 100;\n  border-width: 3px;\n  border-image: linear-gradient(to right, #6adc26, #6adc26);\n  border-image-slice: 1;\n}\n\n/* Reset input */\n.form__field:required,\n.form__field:invalid {\n  box-shadow: none;\n}\n\n.submit_btn {\n  width: 220px;\n  padding: 7px;\n}\n.order_div p {\n  margin: 0;\n}\n\n.comp_main {\n  color: #8d8b8b;\n  background-color: #101010;\n}\n\n.comp_benefits {\n  font-size: 1.3vw;\n  position: absolute;\n  bottom: 47%;\n  left: 41%;\n  z-index: 1;\n  color: #b9abb1;\n}\n\n.comp_benefits h2 {\n  font-size: 2vw;\n}\n\n.compmobbene {\n  bottom: 45%;\n  left: 36%;\n  position: absolute;\n  font-size: 3vw;\n  z-index: 1;\n  color: #b9abb1;\n}\n\n.compmobbene h2 {\n  font-size: 4vw;\n}\n\n.compcontent {\n  max-width: 60%;\n}\n\n.compcontent p {\n  font-size: 22px;\n}\n\n.mobbenif {\n  overflow: hidden !important;\n  position: relative;\n  /* max-width: 100%;\n  max-height: 100%; */\n}\n\n.benefitmobimg {\n  /* transition: transform 0.7s ease-in-out; */\n  animation: rotate 100s linear infinite;\n  /* max-width: 1100px; */\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n/* .benefitmobimg:hover {\n  transform: rotate(60deg);\n} */\n\n.benefitsimg {\n  /* transition: transform 0.7s ease-in-out; */\n  animation: rotate 100s linear infinite;\n}\n\n/* .benefitsimg:hover {\n  transform: rotate(60deg);\n} */\n\n\n.greycircle {\n  position: absolute;\n  bottom: 27%;\n  left: 31%;\n  opacity: 1;\n  width: 38%;\n}\n\n.greycircle1 {\n  position: absolute;\n  bottom: 23%;\n  left: 23%;\n  opacity: 1;\n  width: 53%;\n}\n\n.mobsmiley {\n  width: 60px;\n  height: 60px;\n}\n\n.mobsmiley1 {\n  z-index: 1;\n  width: 65px;\n  height: 63px;\n  background-image: url(\"../../public/images/smile02.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.benitem:hover > .mobsmiley1 {\n  background-image: url(\"../../public/images/smile01.png\");\n}\n.benitem:hover > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 15px;\n}\n\n.benmobbtn1 {\n  background-color: #1f1d1b;\n  color: white;\n  border-radius: 10px;\n  border: 100px;\n  font-size: 24px;\n  width: 250px;\n}\n\n.benmobbtn2 {\n  background-color: #2d62ed;\n  color: white;\n  border-radius: 10px;\n  border: 100px;\n  font-size: 18px;\n  width: 250px;\n}\n\n.verline {\n  height: 40px;\n  width: 2px;\n  background-color: #2d62ed;\n}\n.smiley1img {\n  z-index: 1;\n  width: 25%;\n  background-image: url(\"../../public/images/smile02.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n/* .smiley1img:hover {\n  background-image: url(\"../../public/images/smile01.png\");\n} */\n\n/* .smiley1 > .smiley1img {\n  background-image: url(\"../../public/images/smile01.png\");\n}\n.smiley1 > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 30px;\n} */\n\n.smiley1 {\n  position: absolute;\n  bottom: 70%;\n  right: 72%;\n}\n\n.smiley1 p {\n  font-size: 1vw;\n  border: 5px;\n  border-radius: 30px;\n  line-height: 19px;\n}\n\n\n.smiley2img {\n  width: 37%;\n  background-image: url(\"../../public/images/smile02.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.smiley2:hover > .smiley2img {\n  background-image: url(\"../../public/images/smile01.png\");\n}\n.smiley2:hover > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 30px;\n}\n\n.smiley-hover-effect > div {\n  background-image: url(\"../../public/images/smile01.png\");\n\n}\n.smiley-hover-effect > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 30px;\n\n}\n\n.smiley2 {\n  position: absolute;\n  bottom: 53%;\n  right: 79%;\n  z-index: 1;\n}\n\n.smiley2 p {\n  font-size: 1vw;\n  border: 5px;\n  border-radius: 30px;\n  line-height: 19px;\n}\n\n.smiley3img {\n  z-index: 1;\n  width: 30%;\n  background-image: url(\"../../public/images/smile02.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.smiley3 {\n  position: absolute;\n  bottom: 34%;\n  right: 78%;\n  z-index: 1;\n}\n\n.smiley3 p {\n  font-size: 1vw;\n  border: 5px;\n  border-radius: 30px;\n  line-height: 19px;\n}\n\n.smiley3:hover > .smiley3img {\n  background-image: url(\"../../public/images/smile01.png\");\n}\n.smiley3:hover > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 30px;\n}\n\n.smiley4img {\n  z-index: 1;\n  width: 22%;\n  background-image: url(\"../../public/images/smile02.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.smiley4 {\n  position: absolute;\n  bottom: 18%;\n  right: 68%;\n}\n\n.smiley4 p {\n  font-size: 1vw;\n  border: 5px;\n  border-radius: 30px;\n  line-height: 19px;\n}\n\n.smiley4:hover > .smiley4img {\n  background-image: url(\"../../public/images/smile01.png\");\n}\n.smiley4:hover > p {\n  background-color: #6adc26;\n  color: black;\n  border-radius: 30px;\n}\n\n.visitus {\n  font-size: 12px;\n}\n\n.eclipse {\n  position: absolute;\n  bottom: 18%;\n  left: 18%;\n  width: 20%;\n}\n\n.tech-ben-con1 {\n  position: absolute;\n  bottom: 35%;\n  left: 78%;\n  color: #8d8b8b;\n  width: 300px;\n}\n\n.tech-ben-con1 h6 {\n  font-size: 1.5vw;\n}\n\n.tech-ben-con1 p {\n  font-size: 1vw;\n  color: #7de01f;\n}\n\n.benbtn1 {\n  background-color: #1f1d1b;\n  width: 100%;\n  color: white;\n  font-size: 1vw;\n  border-radius: 10px;\n  border: 100px;\n\n}\n\n.benbtn1:hover {\n  background-color:#1f1d1b; \n  /* text-decoration: underline; */\n  text-underline-offset: 3px;;\n  color: #6adc26;\n  \n}\n.benbtn2 {\n  background-color: #2d62ed;\n  width: 123px;\n  color: white;\n  font-size: 0.9vw;\n  border-radius: 10px;\n  border: 100px;\n  height: 100%;\n}\n.benbtn2:hover {\n  background-color: #6adc26;;\n  width: 123px;\n  color:black;\n  font-weight: 600;\n  font-size: 0.9vw;\n  text-underline-offset: 3px;\n  border-radius: 10px;\n  border: 100px;\n}\n\n/* .pendamic_font{\n  font-size: 1vw !important;\n} */\n\n.tech-card {\n  background-color: #1f1d1b;\n  height: 500px;\n  width: 543px;\n  border-radius: 15px;\n}\n.card_design {\n  background-color: #1f1d1b;\n  height: 460px;\n  width: 500px;\n  border-radius: 15px;\n}\n\n.tech-card p {\n  font-size: 18px;\n}\n\n.techimg1 {\n  width: 200px;\n}\n\n.techimg2 {\n  width: 300px;\n}\n.techimg3 {\n  width: 177px;\n  top: 9%;\n}\n\n.tech-uses-p {\n  font-size: 16px;\n  color: #b5b5b5;\n}\n\n.techimg4 {\n  width: 80%;\n  border-radius: 15px;\n}\n\n.benefits-card {\n  background-color: #1f1d1b;\n  max-height: 75%;\n  width: 80%;\n  border-radius: 20px;\n}\n\n.tech-card-icon {\n  width: 75px;\n}\n\n.benefits-content {\n  width: 25%;\n}\n\n.benefits-content p {\n  font-size: 11px;\n  width: 125px;\n}\n\n.tech-video-text {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  height: 60%;\n  width: 100%;\n  display: grid;\n  place-items: center;\n  background-color: black;\n  color: #fff;\n  font-weight: 600;\n  font-size: 130px;\n  /* Mix Blend Mode does the all magic */\n  mix-blend-mode: multiply;\n}\n\n.tech-video {\n  height: 100%;\n  width: 100%;\n}\n.checkout_btn {\n  background: black;\n  color: white;\n  padding: 3% 39%;\n  border: 0;\n}\n.paymethod_div {\n  background-color: #fcfbda;\n  border: 1px solid #e6e2be;\n  border-radius: 8px;\n}\n\n.form_field_2 {\n  font-family: inherit;\n  width: 100%;\n  border: 0;\n  border-bottom: 2px solid #ccc; /* Replace $gray with the desired color value */\n  outline: 0;\n  color: black; /* Replace $white with the desired color value */\n  padding: 12px 0px;\n  background: transparent;\n  transition: border-color 0.2s;\n}\n.billing_label {\n  position: absolute;\n  cursor: text;\n  top: 32%;\n  left: 7%;\n}\n.nav_product {\n  position: absolute;\n  height: 108px;\n  /* height: 100%; */\n  width: 65px;\n  right: 0;\n  top: 0;\n}\n\n.count_div {\n  border-radius: 50%;\n  border: 0;\n  height: 13px;\n  width: 13px;\n  font-size: 8px;\n  background-color: #1f1d1b;\n  color: white;\n  align-items: center;\n  z-index: 999;\n}\n.cart_count {\n  z-index: 1000;\n}\n.count_icon {\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n}\n\n.bubble1 {\n  position: absolute;\n  bottom: 65%;\n  left: 10%;\n  width: 25%;\n}\n.bubble2 {\n  position: absolute;\n  bottom: 80%;\n  left: 50%;\n  width: 20%;\n  z-index: 1000px;\n}\n.bubble3 {\n  position: absolute;\n  bottom: 85%;\n  left: 75%;\n  width: 14%;\n}\n.bubble4 {\n  position: absolute;\n  bottom: 65%;\n  left: 65%;\n  width: 14%;\n}\n\n.tech-link {\n  position: absolute;\n  bottom: 10%;\n  left: 34%;\n  transition: left 0.3s ease-out;\n}\n\n.tech-link:hover {\n  left: 38%;\n}\n.product_link {\n  color: white;\n  text-decoration: none;\n}\n.product_link:hover {\n  color: white;\n}\n.input-qty {\n  border: none;\n  background-color: white;\n}\n\n.certificate {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.overlay {\n  background: blue;\n  width: 100%;\n  top: 0;\n  position: absolute;\n  bottom: 0;\n  opacity: 0.5;\n}\n.enquiry_logo {\n  top: 10%;\n  left: 32%;\n}\n.vh100 {\n  height: 100vh;\n}\n.checkkk {\n  z-index: -1;\n}\n.width75 {\n  width: 75%;\n}\n\n.custom-accordion .accordion-item {\n  background-color: #171727;\n  border-radius: 15px;\n  border: none !important;\n  border-bottom: none !important;\n  outline: none !important;\n}\n\n.custom-accordion .accordion-button:not(.collapsed) {\n  background-color: #171727 !important;\n  box-shadow: none;\n  color: white;\n  outline: none !important;\n}\n.custom-accordion .accordion-button {\n  background-color: #171727 !important;\n  box-shadow: none;\n  color: white;\n  outline: none !important;\n}\n\n.custom-accordion .accordion-button:focus {\n  box-shadow: none;\n  outline: none;\n  background-color: #171727;\n  color: white;\n}\n.accordion-button:not(.collapsed)::after {\n  content: \"\";\n  transform: rotate(0deg);\n  color: white;\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: auto;\n  content: \"\";\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"%23ffffff\"><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/></svg>');\n  background-repeat: no-repeat;\n  background-size: 1.25rem;\n  transition: transform 0.2s ease-in-out;\n}\n\n.navbar {\n  transition: opacity 0.3s ease;\n  opacity: 1;\n}\n\n.navbar-hidden {\n  opacity: 0;\n}\n\n.fade-in {\n  animation: fadeIn 1s ease-in-out;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-2%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.smooth {\n  transition: opacity 0.3s ease;\n}\nbody::-webkit-scrollbar {\n  width: 5px;\n  /* display: none;            */\n}\n\nbody::-webkit-scrollbar-track {\n  background: black;\n}\n\nbody::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  border: 3px solid #6adc26;\n}\n\n.accordion-button:not(.collapsed)::after {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  transform: rotate(0deg);\n  color: #000;\n}\n\n.aboutus_div h2 {\n  color: #929292;\n  font-size: 27px;\n  margin-top: 45px;\n}\n\n.aboutus_div p,\nh4,\nh5 {\n  color: #929292;\n}\n.custom_padding {\n  margin-top: 10%;\n  margin-bottom: 11%;\n}\n.enquiry_img {\n  height: 600px;\n  object-fit: contain;\n}\n.custom_bottom {\n  bottom: -8%;\n}\n.about_heading {\n  font-size: 60px;\n}\n.about_desc {\n  text-align: center;\n}\n.electron_text {\n  font-size: 60px;\n}\n\n.zoom-in-zoom-out {\n  transition: transform 0.3s ease-out;\n}\n\n.zoom-in-zoom-out:hover {\n  transform: scale(0.9);\n}\n\n.image_effect:hover {\n  transform: translateX(20px);\n}\n.text_hover {\n  color: #c6c3c3;\n}\n.text_hover a {\n  color: #c6c3c3;\n}\n.text_hover a:hover {\n  color: #7de01f;\n}\n\n.certificate_heading{\n  text-decoration: underline;\n  text-decoration-color: #616161;\n  text-underline-offset: 8px;\n}\n.health_font{\n  font-size: 58px;\n  line-height: 58px;\n}\n.girl_img{\n  width: 150px;\n}\n.buy_amazon_btn:hover{\n  background-color: #6adc26;\n  color: white;\n\n}\n.media-img{\n  height: 80px;\n}\n.marquee_display{\n  display: block;\n}\n.blog_font{\n  font-size: 1.3vw;\n}\n.blog_fon2{\n  font-size: 1vw;\n}\n\n.aboutus_text h1{\n  font-size: 70px;\n\n}\n\n.show{\n  display: none;\n}\n.show2{\n  display: block;\n}\n@media only screen and (max-width: 640px) {\n  \n  .show2{\n    display: none;\n  }\n  .show{\n    display: block;\n  }\n  .aboutus_text h1{\n    font-size: 30px;\n  \n  }\n  .blog_font{\n    font-size: 4vw;\n  }\n\n  .blog_fon2{\n    font-size: 3vw;\n  }\n  \n  .marquee_display{\n    display: none;\n  }\n  .girl_img{\n    width:115px ;\n  }\n  .health_font{\n    font-size: 35px;\n    line-height: 40px;\n  }\n  .about_heading {\n    font-size: 44px;\n  }\n  .about_desc {\n    text-align: start;\n  }\n  .nav_product {\n    position: absolute;\n    height: 95px;\n    /* height: 100%; */\n    width: 50px;\n    right: 0;\n    top: 0;\n  }\n\n  .count_icon {\n    position: absolute;\n    bottom: 50%;\n    left: 50%;\n  }\n  .experience_desc {\n    font-size: 4.8vw;\n    line-height: 26px;\n  }\n  \n  .container >div .video_text {\n    \n    top: 0%;\n    left: 0px;\n    height: 100%;\n    width: 100%;\n    display: grid;\n    place-items: center;\n    background-color: #000;\n    color: #fff;\n    font-weight: 600;\n    font-size: 120px;\n    mix-blend-mode: multiply;\n    transform: scale(1.5);\n  }\n  .Revolutionary_text {\n    font-size: 16px;\n    margin-top: -1%;\n  }\n  .width75 {\n    width: 100%;\n  }\n  .container >div .bg-video {\n    width: 100%;\n    height: 100vh;\n  }\n  .tech-video-text {\n    position: absolute;\n    top: 10%;\n    left: 0px;\n    height: 22%;\n    width: 100%;\n    display: grid;\n    place-items: center;\n    background-color: #000;\n    color: #fff;\n    font-size: 50px;\n    mix-blend-mode: multiply;\n  }\n  .benefits-card {\n    background-color: #1f1d1b;\n    max-height: 75%;\n    width: 100%;\n    border-radius: 20px;\n  }\n  .techimg4 {\n    width: 100% !important;\n    border-radius: 15px;\n  }\n  .techimg3 {\n    width: 175px;\n    top: 6%;\n  }\n\n  .hover_desc h1 {\n    font-size: 30px;\n  }\n  .hovermenu_list a {\n    text-transform: capitalize;\n    text-decoration: none;\n    color: #929292;\n    font-size: 18px;\n    line-height: 30px;\n  }\n  .hovermenu_list2 a {\n    text-transform: capitalize;\n    text-decoration: none;\n    color: #6adc26;\n    font-size: 18px;\n    line-height: 30px;\n  }\n  .hovermenu_list2 a:hover {\n    color: #929292;\n  }\n\n  .display{\n    display: none;\n  }\n\n  .welcome_div h4{\n    font-size: 5vw;\n  }\n  .welcome_div p{\n    font-size: 4vw;\n  }\n  .tech-p {\n    font-size: 20px;\n  }\n  .tech-card {\n    height: auto;\n    width: 100% !important;\n  }\n  .card_design {\n    height: auto;\n    width: 100% !important;\n  }\n  .benefits-content {\n    width: 50%;\n  }\n  .check {\n    margin-left: 0%;\n  }\n\n  .benbtn2 {\n    background-color: #2d62ed;\n    width: 50px;\n    color: white;\n    font-size: 0.8vw;\n    border-radius: 10px;\n    border: 100px;\n  }\n\n  .compcontent {\n    max-width: 100%;\n  }\n\n  .card_img {\n    height: 500px;\n    left: -40%;\n  }\n\n  .card_img2 {\n    height: 350px;\n    margin-left: 20%;\n  }\n\n \n  .tech-ben-con1 h6 {\n    font-size: 2vw;\n  }\n  .tech-ben-con1 {\n    width: 80px;\n    bottom: 30%;\n    left: 78%;\n  }\n  .health_container{\n    transform: rotate(-90deg);\n  }  \n  .meet_text {\n    bottom: 36%;\n    font-size: 18px;\n    left: 0%;\n  }\n  .hover_desc h1 {\n    font-size: 30px;\n  }\n\n  .welcome_text h1 {\n  display: none;\n  }\n  .experience_text h1 {\n    display: none;\n\n  }\n  .welcome_mobile_text h1{\n    font-size: 10vw;\n    line-height: 35px;\n  }\n\n  .body_mind_text2{\n    margin-top: 0%;\n    font-size: 13vw;\n    line-height: 3.3rem;\n  }\n  .card_img {\n    height: 350px;\n  }\n  .form__group {\n    position: relative;\n    padding: 20px 0 0;\n    margin-top: 10px;\n    width: 100%;\n  }\n  .vh100 {\n    height: 60vh;\n  }\n\n  .enquiry_img {\n    height: 550px;\n    object-fit: contain;\n  }\n  .custom_bottom {\n    bottom: -7%;\n  }\n  .aboutus_div h2 {\n    color: #929292;\n    font-size: 21px;\n    margin-top: 45px;\n  }\n  .aboutus_div h5 {\n    font-size: 16px;\n  }\n  .electron_text {\n    font-size: 35px;\n  }\n  .TechHoverImg {\n    \n  \n    margin-left: 0px !important;\n  \n}.bgblack {\n  background-color: #101010;\n}\n.mobile_hover_nav{\n  height: 100vh;\n}\n}\n.input-qty {\n  border: none;\n  background-color: white;\n}\n\n\n\n\n.TechHoverImg{\n\n    width: 100%;\n    overflow: hidden;\n    margin-left: 12px;\n    transition: transform 0.3s ease-in-out, margin-left 0.3s ease-in-out;\n\n\n}\n.Tech:hover  .TechHoverImg{\n  margin-left: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
